import React from "react";
import { format } from "date-fns";
import styles from "./MechanismSelectionItem.module.css";


function getImgUrl(imgUrl:string){
  if(imgUrl){
    if(imgUrl.indexOf("http")===-1 && imgUrl.indexOf("//")===-1){
      if(imgUrl.indexOf("jfs")>-1){
        imgUrl = `https://img12.360buyimg.com/img${imgUrl}!cc_260x260`
      }else{
        imgUrl = `https://storage.jd.com/pharos-court/${imgUrl}`
      }
    }
  }
  return imgUrl
}

const announcementStatusObj:any = {
  "10":{
    statusTxt:"待发布"
  },
  "20":{
    statusTxt:"公告中"
  },
  "30":{
    statusTxt:"公告结束"
  },
  "40":{
    statusTxt:"公告中止"
  }
}

function MechanismSelectionItem(props: any) {
  const {
    announcementTitle,
    deadLine,
    publishCompany,
    joinNum,
    mainImgUrl,
    provinceName,
    cityName,
    announcementStatus,
    id,
  } = props;
  return (
    <div className={styles.container}>
      <a 
        className={styles.imgbox}
        href={`https://pcxp.jd.com/xpdetail/${id}`}
        target="_blank"
      >
        <img src={getImgUrl(mainImgUrl)} />
      </a>
      <h4>{announcementTitle}</h4>
      <div className={styles.declaretime}>
        <span>申报期限：</span>
        <em>{format(deadLine,"yyyy-MM-dd HH:mm")}</em>
      </div>
      {provinceName && 
        <div className={styles.addr}>
          <span>通讯地址：</span>
          <em>{provinceName} {cityName||""}</em>
        </div>
      }
      <div className={styles.company}>
        <span>发布单位：</span>
        <em>{publishCompany}</em>
      </div>
      <div className={styles.statusbox}>
        {announcementStatus && <div className={[styles.statustext, announcementStatus<=20 && styles.doing].join(" ")}>{announcementStatusObj[announcementStatus.toString()].statusTxt}</div>}
        <span className={styles.yixiangnum}>{joinNum||0}名意向人</span>
      </div>
    </div>
  );
}

export default MechanismSelectionItem;
